import { useTranslation } from 'react-i18next';
import { styled } from 'goober';

import { TOPBAR_HEIGHT } from '@/features/topbar/topbar';
import { Flexbox } from '@/ui/flexbox/flexbox';

export const PendingProjectsEmptyState = () => {
  const { t } = useTranslation('projects');

  return (
    <Container
      name="pending-projects-empty-state"
      justify="center"
      alignItems="center"
      direction="column"
      gap="10px"
    >
      {t`noPendingCompanies`}
    </Container>
  );
};

const Container = styled(Flexbox)`
  width: 100%;
  height: calc(100vh - ${TOPBAR_HEIGHT} - 198px);

  ${({ theme }) => theme.typography.widget.paragraphMedium};
`;
